import { getDealerSales, queryDispatchUser } from '@api/announcement';
import {
  GetDealerSalesInterface,
  NoticeItemInterface
} from '@api/announcement/type';
import ZeissButton from '@components/button';
import ZeissCollapse from '@components/collapse';
import ZeissInput from '@components/input';
import ZeissModal from '@components/zeiss-modal';
import { COMMON_PLACEHOLDER, ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { SystemCityItemInterface } from '@store/systemCityStore';
import { rendercomponents, RenderFormDomInterface } from '@utils/formRender';
import {
  dateFormat,
  filterProductLine,
  filterBrandLine,
  getCityItem,
  getItemByKey,
  valToString
} from '@utils/tool';
import {
  DataFlagEnum,
  StatusAiEnum,
  StatusAiTextEnum
} from '@views/pages/AnnouncementList/announcement';
import {
  dealerSectorArr,
  initialFromValues,
  initialSubjectMatterItemValues
} from '@views/pages/AnnouncementList/Announcement/CreateAnnouncement';
import { sectorMap, sectorValueMap } from '@views/pages/AnnouncementList/tool';
import {
  Col,
  CollapseProps,
  Form,
  FormListFieldData,
  message,
  Row,
  Space,
  StepProps,
  Steps,
  Tag,
  Tooltip
} from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useImmer } from 'use-immer';
import {
  ANNOUNCEMENT_COLLAPSE_TYPE,
  COMMON_BOOLEAN_MAP,
  COMMON_BOOLEAN_MAP_2,
  DEFAULT_PROJECT_FORM_DATA,
  duringTenderRequired,
  endTenderArr,
  endTenderRequired,
  projectStatusMap,
  PROJECT_MODE,
  subjectMatterBrandKeyArr,
  TARGET_STUFF,
  waittingForTenderArr,
  waittingForTenderRequired,
  use_NOTICE_FORM_LIST
} from './data';
import './CreateProject.scss';
import { SearchOppid } from './SearchOppid';
import { QuestionCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { getTotalAmountWarningMessage, isTotalAmountOverLimit } from './data';
import { checkOppoIdCreatedDate } from '@api/project';
import { OppIdListResInterface } from '@api/project/type';
import AiIconImg from '@assets/image/IconAI.svg';

interface Props {
  record: any; // 标的物
  noticeRecord: any; // 公告详情
  open: boolean;
  setOpen: (val: boolean) => void;
  handleOk?: (data?: any) => void;
  handleCancel?: () => void;
  dicList: any;
  systemCity: SystemCityItemInterface[];
  formRef: any;
  mode?: PROJECT_MODE; // 新建or编辑
  projectList?: any[];
  okBtnText?: string;
  step?: number;
  stepItems?: StepProps[];
  title?: string;
}

const OPP_ID = 'oppId';
const OPP_CREATED_DATE = 'oppoCreatedDate';
const OPP_CLOSE_DATE = 'oppoCloseDate';
const OPP_ID_LIST = 'OppIDList';

interface OppIdFormItem {
  oppId: string;
  oppoCreatedDate: string;
  oppoCloseDate: string;
}

const createEmptyOppItem = (): OppIdFormItem => ({
  [OPP_ID]: '',
  [OPP_CREATED_DATE]: '',
  [OPP_CLOSE_DATE]: ''
});

interface DealerListItemInterface {
  label: string;
  value: string;
  dealerSales: any;
}

const OTHER_INPUT = '其他';
const OTHER_MANUAL_CODE = '99';

export const CreateProject = ({
  open,
  setOpen,
  dicList,
  systemCity,
  handleOk,
  record,
  noticeRecord,
  handleCancel,
  formRef,
  mode,
  okBtnText,
  step,
  stepItems,
  title
}: Props) => {
  // 通过subjectMatterProjectCode判断是修改还是新建
  const {
    subjectMatterProjectCode,
    opportunityStatus,
    createLeads: createLeadsFromRecord,
    createTime
  } = record;
  // const [form] = Form.useForm();
  const form = formRef;
  const [subjectMatterForm] = Form.useForm(); // 标的物form
  const {
    sector,
    noticeType: noticeTypeOptionsList,
    importType: importTypeOptionsList,
    currency,
    productLine,
    projectStatus,
    offlineForm,
    subjectMatterBrand: subjectMatterBrandList
  } = dicList;
  // 一期二期
  const [isVersion2, setIsVersion2] = useState<boolean>(false);
  const [userList, setUserList] = useImmer<any>([]);
  const [curSales, setCurSales] = useImmer([]);
  const [userInfos] = useRecoilState(userInfo);
  const [dealerList, setDealerList] = useState<DealerListItemInterface[]>([]);
  const [searchOppIdOpen, setSearchOppIdOpen] = useState(false);
  const isAdmin = userInfos.roleKeys === ROLE_KEYS_MAP.admin;
  const isSector = userInfos.roleKeys === ROLE_KEYS_MAP.sector;
  const isSales = userInfos.roleKeys === ROLE_KEYS_MAP.sales;
  const isDealer = userInfos.roleKeys === ROLE_KEYS_MAP.dealer;
  const NOTICE_FORM_LIST = use_NOTICE_FORM_LIST();
  const { corpId: corpIdFromStore } = userInfos;

  const isAdminAOrSector = isAdmin || isSector;
  const isSalesOrDealer = isSales || isDealer;

  const [currentOppIdIndex, setCurrentOppIdIndex] = useState(0);

  const isOppIdItemDisabled =
    subjectMatterProjectCode &&
    !(
      valToString(opportunityStatus) === COMMON_BOOLEAN_MAP.no &&
      valToString(createLeadsFromRecord) === COMMON_BOOLEAN_MAP_2.no
    );

  // 台数是否有变化
  const [isSubjectMatterNumberChange, setIsSubjectMatterNumberChange] =
    useState(false);

  // 限制选择负责的销售input自动填入逻辑在编辑弹窗下第一次不生效
  const isSalesTypeFirstRender = useRef(false);

  const isLoseWinStatusFirstRender = useRef(false);

  const isFirstRenderRef = useRef(false);
  // Sector
  const sectorTypeFromForm: string = Form.useWatch('sectorType', form);

  // 行业
  const industryKeyFromForm: string = Form.useWatch('industryKey', form);
  // 项目状态
  const subjectMatterProjectStatusFromForm: string = Form.useWatch(
    'subjectMatterProjectStatus',
    form
  );
  // 省市
  const provinceAndCityFromForm: string = Form.useWatch(
    'provinceAndCity',
    form
  );
  const attendTenderStatusFromForm: string = Form.useWatch(
    'attendTenderStatus',
    form
  );
  // 赢单/输单
  const loseWinStatusFromForm: string = Form.useWatch('loseWinStatus', form);

  const oldCustomerStatusFromForm: string = Form.useWatch(
    'oldCustomerStatus',
    form
  );
  // 是否有Opportunity ID
  const opportunityStatusFromForm: string = Form.useWatch(
    'opportunityStatus',
    form
  );

  // 产品线
  const projectProductLineKeyFromForm: string = Form.useWatch(
    'projectProductLineKey',
    form
  );
  const projectBrandKeyFromForm: string = Form.useWatch(
    'projectBrandKey',
    form
  );
  const projectModelKeyFromForm: string = Form.useWatch(
    'projectModelKey',
    form
  );
  const projectClassKeyFromForm: string = Form.useWatch(
    'projectClassKey',
    form
  );

  // 线下表格
  const offlineFormKeyFromForm: string = Form.useWatch('offlineFormKey', form);

  // 择负责的销售
  const subjectMatterProjectSaleIdFromForm = Form.useWatch(
    'subjectMatterProjectSaleId',
    form
  );

  // 请选择负责的经销商
  const corpIdFromForm = Form.useWatch('corpId', form);
  // 是否创建Leads
  const createLeadsFromForm = Form.useWatch('createLeads', form);
  // 是否已知项目
  const coverageStatusFromForm = Form.useWatch('coverageStatus', form);

  const OppIDListFromForm = Form.useWatch(OPP_ID_LIST, form);

  const subjectMatterNumberFromForm = Form.useWatch(
    'subjectMatter',
    subjectMatterForm
  );
  // 各种状态初始化
  const statusInit = () => {
    isSalesTypeFirstRender.current = false;
    isLoseWinStatusFirstRender.current = false;
    setIsSubjectMatterNumberChange(false);
  };

  const getDealerSalesList = async (data: GetDealerSalesInterface) => {
    const { salesUserId, corpId } = data;
    const res: any = await getDealerSales({
      salesUserId,
      corpId
    });
    const curDealerSalesList =
      res?.dealerCorps?.map((v: any) => {
        return {
          label: v.corpName,
          value: v.corpId,
          dealerSales: v.dealerSales || []
        };
      }) || [];
    setDealerList(curDealerSalesList);

    if (isDealer && res?.dealerCorps) {
      setTimeout(() => {
        form.setFieldsValue({
          corpId: res?.dealerCorps?.[0]?.corpId
        });
      }, 1000);
    }
  };

  const checkOppIdInputHasValue = (
    oppIdList: OppIdFormItem[] = [],
    index: number
  ) => {
    const oppId = oppIdList[index]?.[OPP_ID];
    return !!oppId;
  };

  // 选择负责的销售变化时变更对应经销商
  useEffect(() => {
    if (subjectMatterProjectSaleIdFromForm) {
      getDealerSalesList({
        salesUserId: subjectMatterProjectSaleIdFromForm
      });
    }
    form.setFieldsValue({
      corpId: '',
      dealerUserId: ''
    });
  }, [subjectMatterProjectSaleIdFromForm]);

  useEffect(() => {
    if (sectorTypeFromForm === sectorValueMap.AMS) {
      form.setFieldsValue({
        applicationDirectionKey: ''
      });
    }
  }, [industryKeyFromForm]);

  useEffect(() => {
    const canEdit = !checkIsWFBORWFC();

    if (!canEdit) {
      form.setFieldsValue({
        opportunityStatus: COMMON_BOOLEAN_MAP.no,
        createLeads: COMMON_BOOLEAN_MAP_2.no
      });
    }
    // else {
    //   form.setFieldsValue({
    //     opportunityStatus: null
    //   });
    // }
  }, [
    subjectMatterProjectStatusFromForm,
    projectProductLineKeyFromForm,
    projectClassKeyFromForm
  ]);

  useEffect(() => {
    const formData = formatInitFormData({
      ...noticeRecord,
      ...record
    });

    const { projectProductLineKey } = formData;
    if (
      projectProductLineKeyFromForm &&
      projectProductLineKey?.toString() ===
        projectProductLineKeyFromForm?.toString()
    ) {
      return;
    }
    form.setFieldValue('projectBrandKey', null);
    form.setFieldValue('projectBrandOtherKey', null);
    form.setFieldValue('projectModelKey', null);
    form.setFieldValue('projectModelOtherKey', null);
    form.setFieldValue('projectClassKey', null);
  }, [projectProductLineKeyFromForm]);
  useEffect(() => {
    const formData = formatInitFormData({
      ...noticeRecord,
      ...record
    });

    const { projectBrandKey } = formData;
    if (
      projectBrandKeyFromForm &&
      projectBrandKey?.toString() === projectBrandKeyFromForm?.toString()
    ) {
      return;
    }
    form.setFieldValue('projectBrandOtherKey', null);
    if (projectModelKeyOptions.length === 1) {
      form.setFieldValue('projectModelKey', [projectModelKeyOptions[0].value]);
    } else {
      form.setFieldValue('projectModelKey', null);
    }

    form.setFieldValue('projectModelOtherKey', null);
    form.setFieldValue('projectClassKey', null);
  }, [projectBrandKeyFromForm]);
  useEffect(() => {
    const formData = formatInitFormData({
      ...noticeRecord,
      ...record
    });
    const { projectModelKey, projectModelOtherKey } = formData;
    if (
      projectModelKeyFromForm &&
      projectModelKey?.toString() === projectModelKeyFromForm?.toString()
    ) {
      if (
        projectModelKey[0] ===
        `${OTHER_MANUAL_CODE}${COMMON_PLACEHOLDER}${OTHER_INPUT}`
      ) {
        form.setFieldValue('projectModelOtherKey', projectModelOtherKey);
      }
      return;
    }
    form.setFieldValue('projectModelOtherKey', null);
    if (classTypeOptions.length === 1) {
      form.setFieldValue('projectClassKey', classTypeOptions[0].value);
    } else {
      form.setFieldValue('projectClassKey', null);
    }
  }, [projectModelKeyFromForm]);

  // 经销商直接加载对应经销商,及其下销售
  useEffect(() => {
    if (!corpIdFromStore || !isDealer) return;
    if (!open) return;
    getDealerSalesList({
      // corpId: mockCorpId
      corpId: corpIdFromStore
    });
  }, [corpIdFromStore, open]);

  // 切换后清空 选择赢/输单原因
  useEffect(() => {
    if (!loseWinStatusFromForm || mode === PROJECT_MODE.CREATE) {
      return;
    }
    if (mode === PROJECT_MODE.EDIT && !isLoseWinStatusFirstRender.current) {
      isLoseWinStatusFirstRender.current = true;
      return;
    }

    form.setFieldsValue({
      coreLoseReasonStatus: ''
    });
  }, [loseWinStatusFromForm]);

  const checkIsWFBORWFC = () => {
    const firstStep = getCityItem(
      projectProductLineKeyFromForm?.[0],
      COMMON_PLACEHOLDER
    );
    return (
      firstStep?.label === 'WF' &&
      (projectClassKeyFromForm === `2${COMMON_PLACEHOLDER}B` ||
        projectClassKeyFromForm === `3${COMMON_PLACEHOLDER}C`)
    );
  };

  const getCurSales = async () => {
    const options = {
      sectorType: sectorTypeFromForm,
      provinceAndCity: provinceAndCityFromForm,
      needDefault: true
    };
    const res: any = await queryDispatchUserFn(options);

    form.resetFields(['subjectMatterProjectSaleId']);
    form.setFieldValue(
      'subjectMatterProjectSaleId',
      res?.users?.records?.[0]?.userId
    );

    setUserList(res?.users?.records || []);
    setCurSales(res?.users?.records || []);
  };

  const getSalesList = async () => {
    const options = {
      sectorType: sectorTypeFromForm,
      provinceAndCity: provinceAndCityFromForm,
      needDefault: false
    };
    const res: any = await queryDispatchUserFn(options);
    setUserList(res?.users?.records || []);
  };

  useEffect(() => {
    if (
      !sectorTypeFromForm ||
      !provinceAndCityFromForm ||
      provinceAndCityFromForm.length === 0
    ) {
      return;
    }

    // 判断是否是新建
    if (mode === PROJECT_MODE.CREATE) {
      getCurSales();
      return;
    }

    // 以下都是编辑时的逻辑
    if (!subjectMatterProjectCode) {
      return;
    }

    if (!isSalesTypeFirstRender.current) {
      // getSalesList();
      isSalesTypeFirstRender.current = true;
      return;
    }
    getCurSales();
  }, [sectorTypeFromForm, provinceAndCityFromForm]);

  // 为了限制弹窗出来后因为数据变化造成的Sector相关联动多个表单数据丢失问题
  useEffect(() => {
    setIsVersion2(dealerSectorArr.includes(sectorTypeFromForm));
    const formData = formatInitFormData({
      ...noticeRecord,
      ...record
    });

    const { sectorType } = formData;

    if (sectorType === sectorTypeFromForm) {
      return;
    }

    form.setFieldsValue({
      customerCompanyType: '',
      industryKey: '',
      applicationDirectionKey: '',
      projectProductLineKey: '',
      projectModelKey: null
    });
    setProjectModelKeyOptions([]);
  }, [sectorTypeFromForm]);

  // OppIDList回显逻辑
  useEffect(() => {
    if (!subjectMatterNumberFromForm) {
      return;
    }
    const { [OPP_ID_LIST]: curOppIDList } = form.getFieldsValue([OPP_ID_LIST]);
    const isEditMode = mode === PROJECT_MODE.EDIT;
    // 台数
    const { subjectMatterNumber } = subjectMatterNumberFromForm?.[0] ?? 0;
    // 获取标的物中标总价单位重置标的物中标单价(万元)单位
    const { totalAmountCurrency } = subjectMatterNumberFromForm?.[0] ?? '1';
    const { totalAmount } = subjectMatterNumberFromForm?.[0] ?? 0;
    let subjectMatterPriceDefault = null;
    if (subjectMatterNumber && totalAmount) {
      subjectMatterPriceDefault = (totalAmount / subjectMatterNumber).toFixed(
        2
      );
    }
    subjectMatterForm.setFieldsValue({
      subjectMatter: [
        {
          ...subjectMatterNumberFromForm?.[0],
          subjectMatterPrice: subjectMatterPriceDefault,
          subjectMatterCurrency: totalAmountCurrency
        }
      ]
    });

    const normalizedOppIDList = (
      _.cloneDeep(curOppIDList || []) as OppIdFormItem[]
    ).map((item) => ({
      ...createEmptyOppItem(),
      ...item
    }));

    if (isEditMode && subjectMatterNumber === normalizedOppIDList?.length) {
      return;
    }

    if (isVersion2) {
      form.setFieldsValue({
        [OPP_ID_LIST]:
          isEditMode && normalizedOppIDList.length
            ? normalizedOppIDList
            : [createEmptyOppItem()]
      });
    } else {
      if (isEditMode) {
        const newOppIDList = _.cloneDeep(normalizedOppIDList);
        newOppIDList.length = subjectMatterNumber;

        for (let i = 0; i < subjectMatterNumber; i++) {
          if (!newOppIDList[i]) {
            newOppIDList[i] = createEmptyOppItem();
          } else {
            newOppIDList[i] = {
              ...createEmptyOppItem(),
              ...newOppIDList[i]
            };
          }
        }
        form.setFieldsValue({
          [OPP_ID_LIST]: newOppIDList
        });
      } else {
        form.setFieldsValue({
          [OPP_ID_LIST]: Array.from({ length: subjectMatterNumber }, () =>
            createEmptyOppItem()
          )
        });
      }
    }
    // if (
    //   mode === PROJECT_MODE.EDIT &&
    //   subjectMatterNumber === curOppIDList?.length
    // ) {
    //   return;
    // }
    // form.setFieldsValue({
    //   [OPP_ID_LIST]: isVersion2
    //     ? curOppIDList || [{}]
    //     : Array(subjectMatterNumber).fill({})
    // });

    // if (isVersion2) return;

    if (subjectMatterNumber !== record.subjectMatterNumber && open) {
      setIsSubjectMatterNumberChange(true);
    }
  }, [
    subjectMatterNumberFromForm,
    record,
    opportunityStatusFromForm,
    open,
    isVersion2
  ]);

  const queryDispatchUserFn = async (data: any = {}) => {
    const { sectorType, provinceAndCity, needDefault } = data;
    const provinceItem = getCityItem(provinceAndCity?.[0]);
    const cityCodeItem = getCityItem(provinceAndCity?.[1]);

    const res = await queryDispatchUser({
      pageNumber: 1,
      pageSize: 1000,
      type: 'sales',
      needDefault: needDefault,
      sectorTypeName: sectorMap[sectorType],
      sectorType,
      provinceName: provinceItem?.label,
      cityName: cityCodeItem?.label
    });
    return res;
  };

  const getFirstSector = () => {
    const sectorIds = userInfos.userTypesId || '';
    const firstSectorId = sectorIds.split(',')[0];

    return firstSectorId;
  };

  const initFn = () => {
    const formData = formatInitFormData({
      ...noticeRecord,
      ...record,
      subjectMatter: [
        {
          ...initialSubjectMatterItemValues,
          ...record,
          subjectMatterNumber: record.subjectMatterNumber
            ? record.subjectMatterNumber
            : 1
        }
      ]
    });

    const {
      industryKey,
      customerCompanyType,
      applicationDirectionKey,
      subjectMatter,
      tenderBudgetCurrency,
      successfulPriceCurrency,
      corpId,
      dealerUserId
    } = formData;

    // 初始化公告模块货币单位
    const formCurrencyVal = subjectMatterProjectCode
      ? {
          tenderBudgetCurrency,
          successfulPriceCurrency
        }
      : initialFromValues;

    form.setFieldsValue({
      ...formData,
      ...formCurrencyVal,
      projectName: formData.projectName
        ? formData.projectName
        : formData.noticeName,
      sectorType:
        !formData.sectorType && isSales ? getFirstSector() : formData.sectorType
    });

    subjectMatterForm.setFieldsValue({
      subjectMatter
    });

    setUserList([
      {
        userId: formData.subjectMatterProjectSaleId,
        realName: formData.subjectMatterProjectSaleName
      }
    ]);

    setIsVersion2(dealerSectorArr.includes(formData.sectorType));

    setTimeout(() => {
      form.setFieldsValue({
        industryKey,
        customerCompanyType,
        applicationDirectionKey,
        corpId,
        dealerUserId
      });
    }, 1000);
  };

  useEffect(() => {
    if (!open) {
      isFirstRenderRef.current = false;
      return;
    }
    initFn();
  }, [noticeRecord, open, record]);

  // 兼容客户需求Radio点击能取消。。。
  const formClick = (
    e: Event & {
      target: HTMLButtonElement;
    }
  ) => {
    e.stopPropagation();
    e.preventDefault();

    const { importType } = subjectMatterNumberFromForm?.[0] ?? 0;

    if (e.target.value === importType) {
      subjectMatterForm.setFieldsValue({
        subjectMatter: [
          {
            ...subjectMatterNumberFromForm?.[0],
            importType: ''
          }
        ]
      });
    }
  };

  const salesSelectClick = () => {
    if (
      !sectorTypeFromForm ||
      !provinceAndCityFromForm ||
      provinceAndCityFromForm.length === 0
    )
      return;
    getSalesList();
  };

  // 必填字段format
  const formatRequiredArr = (arr: any[]) => {
    let mapObj: any = [];
    if (
      subjectMatterProjectStatusFromForm === projectStatusMap.waittingForTender
    ) {
      mapObj = waittingForTenderRequired;
    } else if (
      subjectMatterProjectStatusFromForm === projectStatusMap.duringTender
    ) {
      mapObj = duringTenderRequired;
    } else if (
      subjectMatterProjectStatusFromForm === projectStatusMap.endTender
    ) {
      mapObj = endTenderRequired;
    }

    const { subjectMatterBrandKey } = subjectMatterNumberFromForm?.[0] ?? 0;
    const mapArr = arr
      .filter((item) => {
        if (
          item.name === 'subjectMatterBrand' &&
          !subjectMatterBrandKeyArr.find((v) => v === subjectMatterBrandKey)
        ) {
          return false;
        }
        return true;
      })
      .map((item) => {
        // else if (item.name === 'projectModelOtherKey') {
        //   return {
        //     ...item,
        //     required: dealerSectorArr.includes(sectorTypeFromForm)
        //   };
        // }
        if (item.name === 'importType') {
          item.onClick = formClick;
          return {
            ...item,
            required:
              subjectMatterProjectStatusFromForm === projectStatusMap.endTender
          };
        } else if (item.name === 'subjectMatterProjectSaleId') {
          item.onClick = salesSelectClick;
        } else if (
          item.name === 'tenderOrgContacts' ||
          item.name === 'tenderOrgContactsMobile'
        ) {
          item.required =
            createLeadsFromForm === COMMON_BOOLEAN_MAP_2.yes ||
            mapObj[item.name]?.required;
          return item;
        } else if (item.name === 'corpId' && isDealer) {
          item.disabled = true;
          //   if (item.name === 'projectModelKey') {
          //   return {
          //     ...item,
          //     required: dealerSectorArr.includes(sectorTypeFromForm)
          //   };
          // } else
        } else if (item.name === 'coverageStatus') {
          item.disabled = (isSales || isDealer) && mode === PROJECT_MODE.EDIT;
          // return item;
        } else if (item.name === 'offlineFormKey' && isSalesOrDealer) {
          item.required =
            checkIsWFBORWFC() &&
            subjectMatterProjectStatusFromForm &&
            subjectMatterProjectStatusFromForm !==
              projectStatusMap.waittingForTender &&
            coverageStatusFromForm === COMMON_BOOLEAN_MAP.yes;

          return item;
        } else if (item.name === 'createLeads') {
          item.disabled = oppidDisabledFn('createLeads');
          // valToString(record.createLeads) &&
          // !isAdminAOrSector &&
          // (isOppIdItemDisabled || !canEdit);
        } else if (item.name === 'totalAmount') {
          item.required =
            subjectMatterProjectStatusFromForm === projectStatusMap.endTender;
          // valToString(record.createLeads) &&
          // !isAdminAOrSector &&
          // (isOppIdItemDisabled || !canEdit);
        } else if (
          item.name === 'customerCompanyType' &&
          sectorTypeFromForm === '4'
        ) {
          return {
            ...item,
            required: true
          };
        } else if (
          item.name === 'applicationDirectionKey' &&
          sectorTypeFromForm === '6'
        ) {
          return {
            ...item,
            required: true
          };
        } else if (
          item.name === 'customerCompanyType' &&
          sectorTypeFromForm === '6'
        ) {
          return {
            ...item,
            required: false
          };
        } else if (
          item.name === 'customerCompanyType' &&
          sectorTypeFromForm === '5'
        ) {
          return {
            ...item,
            required: false
          };
        } else if (item.name === 'industryKey' && isVersion2) {
          return {
            ...item,
            required: false
          };
        }

        return {
          ...item,
          required: mapObj[item.name]
            ? mapObj[item.name].required
            : item.required
        };
      });

    return mapArr;
  };

  // const [disabledSuccessfulPriceField, setDisabledSuccessfulPriceField] =
  //   useState(false);
  // 格式化数据
  const formatInitFormData = (data: any) => {
    const {
      subjectMatter,
      publishTime,
      tenderOpenTime,
      sectorType,
      customerCompanyType,
      customerCompanyTypeName,
      customerCompanySecondType,
      customerCompanySecondTypeName,
      industryKey,
      applicationDirectionKey,
      applicationDirectionName,
      applicationDirectionSecondKey,
      applicationDirectionSecondName,
      successfulPriceCurrency,
      tenderBudgetCurrency,
      cityCode,
      cityName,
      provinceCode,
      provinceName,
      coverageStatus,
      opportunityStatus,
      lerStatus,
      oppId,
      oppoProductList,
      // currentProcessorUserId,
      attendTenderStatus,
      prosNumStatus,
      loseWinStatus,
      coreLoseReasonStatus,
      oldCustomerStatus,
      projectProductLineKey,
      projectProductLineKeyStr,
      projectProductLineKeyNameStr,
      subjectMatterBrandKey,
      subjectMatterBrand,
      offlineFormKey,
      createLeads,
      projectBrandValueStr,
      projectBrandKeyStr,
      projectModelValueStr,
      projectModelKeyStr,
      classType,
      classTypeValue,
      ...rest
    } = data;

    const newSubjectMatter = subjectMatter?.map((item: any) => {
      return {
        ...item,
        estimatedPurchaseTime: item.estimatedPurchaseTime
          ? dayjs(item.estimatedPurchaseTime)
          : null,
        productLineKey: valToString(item.productLineKey),
        importType: valToString(item.importType),
        subjectMatterCurrency: valToString(item.subjectMatterCurrency),
        totalAmountCurrency: valToString(item.totalAmountCurrency),
        subjectMatterBrandKey: valToString(subjectMatterBrandKey),
        subjectMatterBrand: subjectMatterBrandKeyArr.find(
          (v) => v === valToString(subjectMatterBrandKey)
        )
          ? subjectMatterBrand
          : ''
      };
    });
    // if (data.successfulPrice) {
    //   setDisabledSuccessfulPriceField(true);
    // }

    const provinceAndCity = [];
    if (provinceCode) {
      provinceAndCity.push(`${provinceCode}-${provinceName}`);
    }
    if (cityCode) {
      provinceAndCity.push(`${cityCode}-${cityName}`);
    }
    const newApplicationDirectionKey = [];
    if (applicationDirectionKey) {
      newApplicationDirectionKey.push(
        `${applicationDirectionKey}${COMMON_PLACEHOLDER}${applicationDirectionName}`
      );
    }
    if (applicationDirectionSecondKey) {
      newApplicationDirectionKey.push(
        `${applicationDirectionSecondKey}${COMMON_PLACEHOLDER}${applicationDirectionSecondName}`
      );
    }

    const newCustomerCompanyTypeKey = [];

    if (customerCompanyType) {
      newCustomerCompanyTypeKey.push(
        `${customerCompanyType}${COMMON_PLACEHOLDER}${customerCompanyTypeName}`
      );
    }
    if (customerCompanySecondType) {
      newCustomerCompanyTypeKey.push(
        `${customerCompanySecondType}${COMMON_PLACEHOLDER}${customerCompanySecondTypeName}`
      );
    }

    const projectProductLineKeyStrArr = projectProductLineKeyStr?.split('-');
    const projectProductLineKeyNameStrArr =
      projectProductLineKeyNameStr?.split('-');
    const newProjectProductLineKey = projectProductLineKeyStrArr?.map(
      (v: string, i: number) => {
        return `${v}${COMMON_PLACEHOLDER}${projectProductLineKeyNameStrArr[i]}`;
      }
    );

    // brand key
    const projectBrandKeyStrArr = projectBrandKeyStr?.split('-');
    const projectBrandKeyNameStrArr = projectBrandValueStr?.split('-');
    let projectBrandOtherKey = '';
    const newProjectBrandKey = projectBrandKeyStrArr?.map(
      (v: string, i: number) => {
        if (v === OTHER_MANUAL_CODE) {
          projectBrandOtherKey = projectBrandKeyNameStrArr[i];
        }
        return `${v}${COMMON_PLACEHOLDER}${
          v === OTHER_MANUAL_CODE ? OTHER_INPUT : projectBrandKeyNameStrArr[i]
        }`;
      }
    );

    // model key
    const projectModelKeyStrArr = projectModelKeyStr?.split('-');
    const projectModelKeyNameStrArr = projectModelValueStr?.split('-');
    let projectModelOtherKey = '';
    const newProjectModelKey = projectModelKeyStrArr?.map(
      (v: string, i: number) => {
        if (v === OTHER_MANUAL_CODE) {
          projectModelOtherKey = projectModelKeyNameStrArr?.[i] || '';
        }
        return `${v}${COMMON_PLACEHOLDER}${
          v === OTHER_MANUAL_CODE ? OTHER_INPUT : projectModelKeyNameStrArr[i]
        }`;
      }
    );

    // OppIDList
    return {
      subjectMatter: newSubjectMatter,
      sectorType: valToString(sectorType),
      customerCompanyType: newCustomerCompanyTypeKey,
      industryKey: valToString(industryKey),
      applicationDirectionKey: newApplicationDirectionKey,
      successfulPriceCurrency: valToString(successfulPriceCurrency),
      tenderBudgetCurrency: valToString(tenderBudgetCurrency),
      coverageStatus: valToString(coverageStatus),
      opportunityStatus: valToString(opportunityStatus),
      lerStatus: valToString(lerStatus),
      publishTime: publishTime ? dayjs(publishTime) : null,
      tenderOpenTime: tenderOpenTime ? dayjs(tenderOpenTime) : null,
      provinceAndCity,
      [OPP_ID_LIST]: oppoProductList || [],
      // 以下市销售反馈信息
      attendTenderStatus: valToString(attendTenderStatus),
      prosNumStatus: valToString(prosNumStatus),
      loseWinStatus: valToString(loseWinStatus),
      coreLoseReasonStatus: valToString(coreLoseReasonStatus),
      oldCustomerStatus: valToString(oldCustomerStatus),
      offlineFormKey: valToString(offlineFormKey),
      createLeads: valToString(createLeads),
      // projectProductLineKey: valToString(projectProductLineKey),
      projectProductLineKey: newProjectProductLineKey,
      projectBrandKey: newProjectBrandKey,
      projectBrandOtherKey: projectBrandOtherKey,
      projectModelKey: dealerSectorArr.includes(sectorType?.toString())
        ? projectModelKeyStr
          ? newProjectModelKey
          : ''
        : null,
      projectModelOtherKey: projectModelOtherKey,
      projectClassKey:
        classType && classTypeValue
          ? `${classType}${COMMON_PLACEHOLDER}${classTypeValue}`
          : '',
      ...rest
    };
  };

  const formatProjectProductLineKeyMap = (arr: string[]) => {
    return arr?.reduce(
      (pre: { key: any; label: any }, cur: string) => {
        const curItem = cur.split(COMMON_PLACEHOLDER);
        pre.key = pre.key ? pre.key + '-' + curItem[0] : curItem[0];
        pre.label = pre.label ? pre.label + '-' + curItem[1] : curItem[1];
        return pre;
      },
      {
        key: '',
        label: ''
      }
    );
  };

  const formatProjectBrandKeyMap = (
    arr: string[],
    projectBrandOtherKey: string
  ) => {
    return arr?.reduce(
      (pre: { key: any; label: any }, cur: string) => {
        const curItem = cur.split(COMMON_PLACEHOLDER);
        pre.key = pre.key ? pre.key + '-' + curItem[0] : curItem[0];
        pre.label = pre.label
          ? pre.label +
            '-' +
            (curItem[0] === OTHER_MANUAL_CODE
              ? projectBrandOtherKey
              : curItem[1])
          : curItem[1];
        return pre;
      },
      {
        key: '',
        label: ''
      }
    );
  };

  const formatProjectModelKeyMap = (
    arr: string[],
    projectModelOtherKey: string
  ) => {
    if (arr?.length) {
      return arr?.reduce(
        (pre: { key: any; label: any }, cur: string) => {
          const curItem = cur.split(COMMON_PLACEHOLDER);
          pre.key = pre.key ? pre.key + '-' + curItem[0] : curItem[0];
          pre.label = pre.label
            ? pre.label +
              '-' +
              (curItem[0] === OTHER_MANUAL_CODE
                ? projectModelOtherKey
                : curItem[1])
            : curItem[0] === OTHER_MANUAL_CODE
            ? projectModelOtherKey
            : curItem[1];
          return pre;
        },
        {
          key: '',
          label: ''
        }
      );
    } else {
      if (projectModelOtherKey) {
        return {
          key: OTHER_MANUAL_CODE,
          label: projectModelOtherKey
        };
      } else {
        return {
          key: '',
          label: ''
        };
      }
    }
  };

  const formatProjectClassKeyMap = (val: string) => {
    if (val) {
      const arr = val.split(COMMON_PLACEHOLDER);
      return {
        key: arr[0],
        label: arr[1]
      };
    } else {
      return {
        key: '',
        label: ''
      };
    }
  };

  const createProjectHandle = async () => {
    try {
      const [formResult, subjectMatterResult] = await Promise.allSettled([
        form.validateFields(),
        subjectMatterForm.validateFields()
      ]);

      if (
        formResult.status === 'rejected' ||
        subjectMatterResult.status === 'rejected'
      ) {
        return;
      }
      const values = formResult.value;
      const subjectMatterValues = subjectMatterResult.value;
      const {
        provinceAndCity,
        tenderBudgetCurrency,
        subjectMatterProjectStatus,
        publishTime,
        tenderOpenTime,
        noticeType,
        customerCompanyType,
        industryKey,
        applicationDirectionKey,
        sectorType,
        successfulPriceCurrency,
        subjectMatterProjectSaleId,
        projectProductLineKey,
        projectBrandKey,
        projectBrandOtherKey,
        projectModelKey,
        projectModelOtherKey,
        projectClassKey,
        dealerUserId,
        corpId,
        [OPP_ID_LIST]: OppIDList,
        ...otherNoticeValues
      } = values;
      const validOppIDList = (OppIDList || []).filter(
        (item: OppIdFormItem) => item?.[OPP_ID]
      );
      let oppoProductItems: OppIdListResInterface[] = validOppIDList.map(
        (item: OppIdFormItem) => ({
          oppoId: item[OPP_ID],
          oppoCreatedDate: item[OPP_CREATED_DATE],
          oppoCloseDate: item[OPP_CLOSE_DATE]
        })
      );

      const tenderBudgetCurrencyItem = getItemByKey(
        currency,
        'dictKey',
        tenderBudgetCurrency
      );

      const provinceItem = getCityItem(provinceAndCity[0]);
      const cityCodeItem = getCityItem(provinceAndCity[1]);
      // 应用方向
      const applicationItem = getCityItem(
        applicationDirectionKey[0],
        COMMON_PLACEHOLDER
      );
      const applicationSecondItem = getCityItem(
        applicationDirectionKey[1],
        COMMON_PLACEHOLDER
      );
      // 客户单位类型
      const customerCompanyTypeItem = getCityItem(
        customerCompanyType[0],
        COMMON_PLACEHOLDER
      );
      const customerCompanyTypeSecondItem = getCityItem(
        customerCompanyType[1],
        COMMON_PLACEHOLDER
      );

      const projectProductLineKeyMap = formatProjectProductLineKeyMap(
        projectProductLineKey
      );

      const projectBrandKeyMap = formatProjectBrandKeyMap(
        projectBrandKey,
        projectBrandOtherKey
      );
      const projectModelKeyMap = formatProjectModelKeyMap(
        projectModelKey,
        projectModelOtherKey
      );
      const projectClassKeyMap = formatProjectClassKeyMap(projectClassKey);

      const sectorOptionsItem = getSectorRelatedOption();
      const curCorp = dealerList?.find((item) => item.value === values.corpId);
      const corpName = curCorp?.label || '';
      const dealerUserName =
        curCorp?.dealerSales.find(
          (item: any) => item.userId === values.dealerUserId
        )?.realName || '';
      const offlineFormValue =
        offlineForm?.find((item: any) => item.dictKey === values.offlineFormKey)
          ?.dictValue || '';
      const params = {
        ...otherNoticeValues,
        dataFlag: isVersion2 ? DataFlagEnum.dealer : DataFlagEnum.directSelling,
        corpName,
        corpId,
        dealerUserId: corpId ? dealerUserId : '',
        dealerUserName,
        offlineFormValue,
        offlineFormKey: values.offlineFormKey || '',
        offlineFormId: values.offlineFormKey ? values.offlineFormId : '',
        // projectProductLineKey,
        // projectProductLineValue: getItemByKey(
        //   projectProductLine,
        //   'dictKey',
        //   projectProductLineKey
        // )?.dictValue,
        projectProductLineKeyStr: projectProductLineKeyMap?.key,
        projectProductLineKeyNameStr: projectProductLineKeyMap?.label,
        projectBrandKeyStr: projectBrandKeyMap?.key,
        projectBrandValueStr: projectBrandKeyMap?.label,
        projectModelKeyStr: projectModelKeyMap?.key,
        projectModelValueStr: projectModelKeyMap?.label,

        subjectMatterProjectSaleId,
        subjectMatterProjectSaleName: getItemByKey(
          [...userList, ...curSales],
          'userId',
          subjectMatterProjectSaleId
        )?.realName,
        sectorType,
        sectorTypeValue: getItemByKey(sector, 'dictKey', sectorType)?.dictValue,
        industryKey,
        industryName: getItemByKey(
          sectorOptionsItem?.industry,
          'dictKey',
          industryKey
        )?.dictValue,
        noticeType,
        noticeTypeValue: getItemByKey(
          noticeTypeOptionsList,
          'dictKey',
          noticeType
        )?.dictValue,
        subjectMatterProjectStatus,
        subjectMatterProjectStatusValue: getItemByKey(
          projectStatus,
          'dictKey',
          subjectMatterProjectStatus
        )?.dictValue,
        applicationDirectionKey: applicationItem?.code ?? 0,
        applicationDirectionName: applicationItem?.label ?? '',
        applicationDirectionSecondKey: applicationSecondItem?.code ?? 0,
        applicationDirectionSecondName: applicationSecondItem?.label ?? '',
        customerCompanyType: customerCompanyTypeItem?.code ?? 0,
        customerCompanyTypeName: customerCompanyTypeItem?.label ?? '',
        customerCompanySecondType: customerCompanyTypeSecondItem?.code ?? 0,
        customerCompanySecondTypeName:
          customerCompanyTypeSecondItem?.label ?? '',
        provinceCode: provinceItem?.code,
        provinceName: provinceItem?.label,
        cityCode: cityCodeItem?.code,
        cityName: cityCodeItem?.label,
        publishTime: dateFormat(publishTime),
        tenderOpenTime: dateFormat(tenderOpenTime),
        tenderBudgetCurrency,
        classType: projectClassKeyMap.key,
        classTypeValue: projectClassKeyMap.label,
        tenderBudgetCurrencyValue: tenderBudgetCurrency
          ? tenderBudgetCurrencyItem?.dictValue
          : null,
        successfulPriceCurrency,
        successfulPriceCurrencyValue: getItemByKey(
          currency,
          'dictKey',
          successfulPriceCurrency
        )?.dictValue,
        oppId:
          values.opportunityStatus === COMMON_BOOLEAN_MAP.yes
            ? validOppIDList
                .map((item: OppIdFormItem) => item[OPP_ID])
                .join() || ''
            : ''
      };
      const findSubjectMatterNumber =
        subjectMatterValues.subjectMatter.findIndex(
          (v: { subjectMatterNumber: number }) => v.subjectMatterNumber > 1000
        );
      if (findSubjectMatterNumber >= 0) {
        message.error('标的物台数不能超过1000');
        return;
      }
      const subjectMatterParams = subjectMatterValues.subjectMatter.map(
        (v: any) => {
          const {
            productLineKey,
            importType,
            subjectMatterCurrency,
            estimatedPurchaseTime,
            totalAmountCurrency,
            subjectMatterBrandKey,
            subjectMatterBrand
          } = v;
          return {
            ...v,
            subjectMatterBrandKey,
            subjectMatterBrand:
              subjectMatterBrand ||
              getItemByKey(
                subjectMatterBrandList,
                'dictKey',
                subjectMatterBrandKey
              )?.dictValue,
            productLineName: getItemByKey(
              productLine,
              'dictKey',
              productLineKey
            )?.dictValue,
            importTypeValue: getItemByKey(
              importTypeOptionsList,
              'dictKey',
              importType
            )?.dictValue,
            subjectMatterCurrencyValue: getItemByKey(
              currency,
              'dictKey',
              subjectMatterCurrency
            )?.dictValue,
            totalAmountCurrencyValue: getItemByKey(
              currency,
              'dictKey',
              totalAmountCurrency
            )?.dictValue,
            estimatedPurchaseTime: dateFormat(estimatedPurchaseTime)
          };
        }
      );

      // if (!subjectMatterProjectSaleId) {
      //   message.warning('请先选择负责的销售');
      //   return;
      // }

      let checkOppIdListRes;
      let oppoProductList = validOppIDList;

      if (
        params.opportunityStatus === COMMON_BOOLEAN_MAP.yes &&
        !isAdminAOrSector
      ) {
        checkOppIdListRes = await handleCheckOppoId(oppoProductItems);
      } else if (subjectMatterProjectCode && isDealer && record.oppId) {
        checkOppIdListRes = record.oppId?.split(',').map((v: string) => ({
          oppId: v,
          code: 999,
          message: ''
        }));
        oppoProductList = record.oppoProductList;
        params.oppId = record.oppId;
      }

      // return

      // 是否可以执行新建操作
      // const { successfulPrice, successfulPriceRemark } = params;
      handleProjectFn({
        ...subjectMatterParams[0],
        ...DEFAULT_PROJECT_FORM_DATA,
        ...params,
        checkOppIdList: checkOppIdListRes,
        oppoProductList
      });
      statusInit();
      // if (
      //   subjectMatterProjectStatusFromForm !== projectStatusMap.endTender ||
      //   successfulPrice ||
      //   successfulPriceRemark
      // ) {
      //   handleProjectFn({
      //     ...subjectMatterParams[0],
      //     ...DEFAULT_PROJECT_FORM_DATA,
      //     ...params,
      //     checkOppIdList: checkOppIdListRes
      //   });
      //   statusInit();
      // } else {
      //   message.error(subjectMatterErrorText);
      // }
      // return;
    } catch (error) {
      console.log('error', error);
    }
  };

  // 项目回调
  const handleProjectFn = async (data: NoticeItemInterface) => {
    handleOk?.(data);
  };

  const onFormChange = () => {};

  const getSectorRelatedOption = () => {
    const sectorDictItem = dicList.sectorDict?.[sectorMap[sectorTypeFromForm]];
    return sectorDictItem || {};
  };

  const [projectModelKeyOptions, setProjectModelKeyOptions] = useState<any[]>(
    []
  );
  const [classTypeOptions, setClassTypeOptions] = useState<any[]>([]);

  // 下拉
  const renderSelectOptions = (data: any) => {
    const { name, optionsListKey } = data;
    let sectorOptionsItem = null;
    if (sectorTypeFromForm) {
      sectorOptionsItem = getSectorRelatedOption();
    }
    // Sector下拉联动
    if (name === 'customerCompanyType' && sectorTypeFromForm) {
      const { customerCompanyType } = sectorOptionsItem;
      return customerCompanyType;
    } else if (name === 'industryKey' && sectorTypeFromForm) {
      const { industry } = sectorOptionsItem;
      return industry;
    } else if (name === 'applicationDirectionKey' && sectorTypeFromForm) {
      const { applicationDirection, industry } = sectorOptionsItem;
      // AMS行业和应用方向联动逻辑
      if (sectorTypeFromForm === sectorValueMap.AMS) {
        const item = industry.find(
          (v: any) => v.dictKey === industryKeyFromForm
        );
        return item?.children || [];
      } else {
        return applicationDirection || [];
      }
    } else if (name === 'subjectMatterProjectSaleId') {
      return userList;
    } else if (name === 'provinceAndCity') {
      return systemCity;
    } else if (
      name === 'projectProductLineKey' &&
      !dealerSectorArr.includes(sectorTypeFromForm)
    ) {
      return filterProductLine(
        dicList?.['projectProductLine'],
        'projectProductLine'
      );
    } else if (
      name === 'projectProductLineKey' &&
      dealerSectorArr.includes(sectorTypeFromForm)
    ) {
      return filterProductLine(
        dicList?.['projectProductLinePhaseTwo'],
        'projectProductLinePhaseTwo'
      );
    } else if (
      name === 'projectBrandKey' &&
      !dealerSectorArr.includes(sectorTypeFromForm) &&
      projectProductLineKeyFromForm?.length
    ) {
      return filterBrandLine(
        dicList?.['projectProductLine'],
        'projectBrand',
        projectProductLineKeyFromForm
      );
    } else if (
      name === 'projectBrandKey' &&
      dealerSectorArr.includes(sectorTypeFromForm) &&
      projectProductLineKeyFromForm?.length
    ) {
      return filterBrandLine(
        dicList?.['projectProductLinePhaseTwo'],
        'projectBrand',
        projectProductLineKeyFromForm
      );
    } else if (
      name === 'projectModelKey' &&
      !dealerSectorArr.includes(sectorTypeFromForm) &&
      projectProductLineKeyFromForm?.length &&
      projectBrandKeyFromForm?.length
    ) {
      return filterBrandLine(
        dicList?.['projectProductLine'],
        'projectModel',
        projectProductLineKeyFromForm.concat(projectBrandKeyFromForm)
      );
    } else if (
      name === 'projectModelKey' &&
      dealerSectorArr.includes(sectorTypeFromForm) &&
      projectProductLineKeyFromForm?.length &&
      projectBrandKeyFromForm?.length
    ) {
      const options = filterBrandLine(
        dicList?.['projectProductLinePhaseTwo'],
        'projectModel',
        projectProductLineKeyFromForm.concat(projectBrandKeyFromForm)
      );
      setProjectModelKeyOptions(options);
      return options;
    } else if (
      name === 'projectClassKey' &&
      projectProductLineKeyFromForm?.length &&
      projectBrandKeyFromForm?.length &&
      projectModelKeyFromForm?.length
    ) {
      const options = filterBrandLine(
        dicList?.['projectProductLinePhaseTwo'],
        'projectClassType',
        projectProductLineKeyFromForm
          .concat(projectBrandKeyFromForm)
          .concat(projectModelKeyFromForm)
      );
      setClassTypeOptions(options);
      return options;
    } else if (name === 'corpId') {
      return dealerList;
    } else if (name === 'dealerUserId') {
      if (!corpIdFromForm) {
        return [];
      }
      const dealerUserArr: any =
        dealerList?.find(
          (v: DealerListItemInterface) => v.value === corpIdFromForm
        ) || [];

      const { dealerSales = [] } = dealerUserArr;

      return dealerSales
        ?.filter((v: any) => v.userId)
        .map((v: any) => {
          return {
            label: v.realName,
            value: v.userId
          };
        });
    } else if (
      name === 'subjectMatterProjectStatus' &&
      mode === PROJECT_MODE.EDIT &&
      isSalesOrDealer
    ) {
      const projectStatusArr = _.cloneDeep(dicList[optionsListKey] ?? []).map(
        (v: any) => {
          v.disabled = v.dictKey < record.subjectMatterProjectStatus;
          return v;
        }
      );
      return projectStatusArr;
    } else if (name === 'sectorType' && isDealer) {
      const sectorTypeList = _.cloneDeep(dicList[optionsListKey] ?? []).filter(
        (v: any) => dealerSectorArr.includes(v.dictKey)
      );
      return sectorTypeList;
    }
    return dicList[optionsListKey] ?? [];
  };

  const handleCheckOppoId = async (oppItems: OppIdListResInterface[]) => {
    if (!oppItems.length || isAdminAOrSector) return;
    try {
      const values = await form.getFieldsValue();
      const { publishTime } = values;
      const res = await checkOppoIdCreatedDate({
        publishTime: dateFormat(publishTime) || '',
        oppoProductList: oppItems.map((item) => ({
          oppId: item.oppoId,
          oppoCreatedDate: item.oppoCreatedDate,
          oppoCloseDate: item.oppoCloseDate
        }))
      });

      const failList = (res || []).filter((item: any) => {
        return item.code !== 0 && item.message;
      });

      if (failList.length) {
        message.warning({
          duration: 4,
          content: failList
            .map((item: any) => `${item.oppId}: ${item.message}`)
            .join('；')
        });
      }

      return res || [];
    } catch (error) {}
  };

  // admin/sector 对oppid进行编辑后，清空该条数据的oppoCloseDate和oppoCreatedDate
  const handleOppIdInputChange = (index: number, value: string) => {
    const currentOppIdList = _.cloneDeep(
      form.getFieldValue(OPP_ID_LIST) || []
    ) as OppIdFormItem[];

    currentOppIdList[index] = {
      ...createEmptyOppItem(),
      ...currentOppIdList[index],
      [OPP_ID]: value,
      [OPP_CREATED_DATE]: '',
      [OPP_CLOSE_DATE]: ''
    };

    form.setFieldsValue({
      [OPP_ID_LIST]: currentOppIdList
    });
  };

  // OppID input 的生成逻辑
  const renderOppIDArr = (key: string | number) => {
    return (
      <Form.List name={OPP_ID_LIST} key={key}>
        {(fields) =>
          fields.map((field, index) => {
            const disabledLimit =
              !isAdminAOrSector &&
              isOppIdItemDisabled &&
              !isSubjectMatterNumberChange &&
              checkOppIdInputHasValue(OppIDListFromForm, index);

            return (
              <Col span={7} key={field.key}>
                <Form.Item
                  {...field}
                  key={field.key}
                  label={<Space>{`Opp ID_0${index + 1}`}</Space>}
                  name={[field.name, OPP_ID]}
                  rules={[
                    {
                      required: true,
                      message: '请输入Opp ID'
                    }
                    // {
                    //   required:
                    //     subjectMatterProjectStatusFromForm ===
                    //     projectStatusMap.duringTender
                    // }
                  ]}
                >
                  <ZeissInput
                    placeholder={isSales ? '请点击搜索图标进行查询' : '请输入'}
                    disabled={disabledLimit || !!isSales}
                    className="oppid-input"
                    onChange={(e) =>
                      handleOppIdInputChange(index, e.target.value)
                    }
                    suffix={
                      !disabledLimit ? (
                        <div
                          className="oppid-search-icon"
                          onClick={() => onOppIdModalOpen(index)}
                        >
                          <SearchOutlined />
                          查询
                        </div>
                      ) : null
                    }
                  />
                </Form.Item>
              </Col>
            );
          })
        }
      </Form.List>
    );
  };

  const renderOptional = (item: any) => {
    if (!createTime || !item.optional) {
      return null;
    }
    const aiFlag = noticeRecord?.aiFlag || record.aiFlag;
    if (aiFlag) {
      const statusAi = noticeRecord?.statusAi || record.statusAi;
      const statusValueAi = noticeRecord?.statusValueAi || record.statusValueAi;
      if (
        statusAi === StatusAiEnum.FAILED ||
        statusAi === StatusAiEnum.RUNNING
      ) {
        return (
          <div className="sales_feedback_ai_optional">
            {item.optional.text}
            {statusValueAi}
          </div>
        );
      } else {
        const value = item.optional?.valueKey
          ? record?.[item.optional.valueKey]
          : item.optional?.value;

        if (value) {
          return (
            <div className="sales_feedback_ai_optional">
              {item.optional.text}
              {value}
            </div>
          );
        } else {
          return (
            <div className="sales_feedback_ai_optional">
              {StatusAiTextEnum.manual}
            </div>
          );
        }
      }
    } else {
      return (
        <div className="sales_feedback_ai_optional">
          {StatusAiTextEnum.manual}
        </div>
      );
    }
  };

  const renderForm = (data: any[] = [], formRef = form) => {
    const obj: RenderFormDomInterface = {
      optionCallback: renderSelectOptions,
      systemCity
    };
    return (
      <Form
        form={formRef}
        layout="vertical"
        onValuesChange={onFormChange}
        initialValues={initialFromValues}
        preserve={false}
      >
        <Row gutter={[24, 0]} justify={'space-between'}>
          {data.map((item) => {
            const { type, name } = item;
            if (type === 'custom' && name === 'OppIDArr') {
              return renderOppIDArr(name);
            }
            return (
              <Col span={7} key={name}>
                <Form.Item
                  label={item.label}
                  name={item.name}
                  rules={
                    item.rules ? item.rules : [{ required: item.required }]
                  }
                >
                  {rendercomponents({
                    ...obj,
                    data: item,
                    dicList
                  })}
                </Form.Item>
                {renderOptional(item)}
              </Col>
            );
          })}
        </Row>
      </Form>
    );
  };

  const CollapseItems: CollapseProps['items'] = [
    {
      key: ANNOUNCEMENT_COLLAPSE_TYPE.NOTICE,
      label: '项目信息',
      children: renderForm(formatRequiredArr(NOTICE_FORM_LIST), form)
    }
  ];

  const onCollapseItemDelete = (data: any) => {
    const index = data.panelKey.replace(
      ANNOUNCEMENT_COLLAPSE_TYPE.TARGET_STUFF + '_',
      ''
    );
    const oldData = subjectMatterForm.getFieldsValue();
    let newData = _.cloneDeep(oldData.subjectMatter);
    newData.splice(index, 1);
    subjectMatterForm.setFieldsValue({
      subjectMatter: newData
    });
  };

  // 标的物删除按钮，第一个没有，其他的都有删除按钮
  const renderExpandIconCallback = (
    props: any,
    collapseItemKey: string | number = ''
  ) => {
    const { panelKey } = props;
    if (panelKey === collapseItemKey) {
      return;
    } else {
      return (
        <ZeissButton
          type="link"
          danger
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCollapseItemDelete(props);
          }}
        >
          删除
        </ZeissButton>
      );
    }
  };

  const getSubjectMatterRules = (item: any, fieldName: number) => {
    const baseRules = item.rules
      ? [...item.rules]
      : [{ required: item.required }];

    if (item.name !== 'totalAmount') {
      return baseRules;
    }

    return [
      ...baseRules,
      {
        warningOnly: true,
        validator: (_: any, value: number | string) => {
          const totalAmountCurrency = subjectMatterForm.getFieldValue([
            'subjectMatter',
            fieldName,
            'totalAmountCurrency'
          ]);

          if (!isTotalAmountOverLimit(value, totalAmountCurrency)) {
            return Promise.resolve();
          }

          return Promise.reject(
            new Error(getTotalAmountWarningMessage(totalAmountCurrency))
          );
        }
      }
    ];
  };

  // 标的物form表单渲染逻辑
  const formListRender = (fields: FormListFieldData[]) => {
    // const { add, remove, move } = operation;
    const CollapseSubjectMatterArr: CollapseProps['items'] = [];
    const obj: RenderFormDomInterface = {
      optionCallback: renderSelectOptions,
      systemCity
    };

    const curFromData = subjectMatterForm.getFieldsValue();

    fields.map((field, index) => {
      const { name } = field;
      CollapseSubjectMatterArr.push({
        key: ANNOUNCEMENT_COLLAPSE_TYPE.TARGET_STUFF + '_' + index,
        label:
          index === 0 ? (
            '标的物'
          ) : (
            <>
              <span className="collapse-pane">新增标的物</span>
              {curFromData.subjectMatter?.[index]?.subjectMatterName}
            </>
          ),
        children: (
          <Row gutter={[24, 0]} justify={'space-between'}>
            {formatRequiredArr(TARGET_STUFF).map((item) => (
              <Col span={7} key={item.name}>
                {item.name === 'totalAmount' ? (
                  <Form.Item
                    label={item.label}
                    name={[name, item.name]}
                    dependencies={[
                      ['subjectMatter', name, 'totalAmountCurrency']
                    ]}
                    rules={getSubjectMatterRules(item, name as number)}
                  >
                    {rendercomponents({ ...obj, data: item, dicList }, field)}
                  </Form.Item>
                ) : (
                  <Form.Item
                    label={item.label}
                    name={[name, item.name]}
                    rules={
                      item.rules ? item.rules : [{ required: item.required }]
                    }
                  >
                    {rendercomponents({ ...obj, data: item, dicList }, field)}
                  </Form.Item>
                )}
              </Col>
            ))}
          </Row>
        )
      });
      return fields;
    });

    return (
      <ZeissCollapse
        items={CollapseSubjectMatterArr}
        defaultActiveKey={[CollapseSubjectMatterArr[0]?.key ?? '']}
        accordion
        renderExpandIcon={(data) =>
          renderExpandIconCallback(data, CollapseSubjectMatterArr[0].key || '')
        }
      />
    );
  };

  // 标的物折叠面板
  const renderSubjectMatterCollapse = () => {
    return (
      <Form
        form={subjectMatterForm}
        layout="vertical"
        onValuesChange={onFormChange}
        preserve={false}
        initialValues={{
          subjectMatter: [initialSubjectMatterItemValues]
        }}
      >
        <Form.List name="subjectMatter">{formListRender}</Form.List>
      </Form>
    );
  };

  const onModalCancel = () => {
    // form.resetFields();
    statusInit();
    setOpen(false);
    handleCancel?.();
  };

  // 控制sales中的表单联动
  const handleSalesFormArr = () => {
    let newSalesFormArr = [];
    if (subjectMatterProjectStatusFromForm === projectStatusMap.endTender) {
      newSalesFormArr = endTenderArr;
    } else {
      newSalesFormArr = waittingForTenderArr;
    }
    return formatRequiredArr(
      formatOppIdArr(formatAllStatusArr(newSalesFormArr))
    );
  };

  // 多个项目状态下都需要foamt的表单逻辑
  const formatAllStatusArr = (arr: any[] = []) => {
    return arr
      .filter((v) => {
        // 结束招标下需要处理的逻辑
        if (subjectMatterProjectStatusFromForm === projectStatusMap.endTender) {
          if (
            v.name === 'prosNumStatus' &&
            (!attendTenderStatusFromForm ||
              attendTenderStatusFromForm !== COMMON_BOOLEAN_MAP.yes ||
              isVersion2)
          ) {
            return false;
          } else if (
            v.name === 'coreLoseReasonStatus' &&
            !loseWinStatusFromForm
          ) {
            return false;
          } else if (v.name === 'oldCustomerStatus') {
            return !isVersion2;
          } else if (
            v.name === 'oldCustomerModel' &&
            (!oldCustomerStatusFromForm ||
              oldCustomerStatusFromForm !== COMMON_BOOLEAN_MAP.yes)
          ) {
            return false;
          }
        }

        // 所有状态下都需要处理的逻辑
        if (isDealer && v.name === 'subjectMatterProjectSaleId') {
          return false;
        } else if (isDealer && v.name === 'opportunityStatus') {
          return false;
        } else if (
          !(
            subjectMatterProjectStatusFromForm ===
              projectStatusMap.waittingForTender &&
            opportunityStatusFromForm === COMMON_BOOLEAN_MAP.no
          ) &&
          v.name === 'createLeads'
        ) {
          return false;
        } else if (v.name === 'projectBrandOtherKey') {
          return (
            projectBrandKeyFromForm &&
            projectBrandKeyFromForm?.includes(
              `${OTHER_MANUAL_CODE}${COMMON_PLACEHOLDER}${OTHER_INPUT}`
            )
          );
        } else if (v.name === 'projectModelKey') {
          return dealerSectorArr.includes(sectorTypeFromForm);
        } else if (v.name === 'projectModelOtherKey') {
          return (
            (projectModelKeyFromForm &&
              projectModelKeyFromForm?.includes(
                `${OTHER_MANUAL_CODE}${COMMON_PLACEHOLDER}${OTHER_INPUT}`
              )) ||
            !dealerSectorArr.includes(sectorTypeFromForm)
          );
        } else if (v.name === 'projectClassKey') {
          return projectProductLineKeyFromForm?.includes(
            `12${COMMON_PLACEHOLDER}WF`
          );
        } else if (v.name === 'offlineFormId') {
          return offlineFormKeyFromForm;
        } else if (v.name === 'corpId') {
          return isVersion2;
        } else if (v.name === 'dealerUserId') {
          return isVersion2 && corpIdFromForm;
        } else if (v.name === 'offlineFormKey') {
          return isVersion2;
        }
        return true;
      })
      .map((item) => {
        if (item.name === 'coreLoseReasonStatus') {
          return {
            ...item,
            label:
              loseWinStatusFromForm === '1' ? '选择赢单原因' : '选择输单原因',
            optionsListKey:
              loseWinStatusFromForm === '1' ? 'coreWinReason' : 'coreLoseReason'
          };
        }
        return {
          ...item
        };
      });
  };

  const oppidDisabledFn = (key: string) => {
    if (isAdminAOrSector) {
      return false;
    }
    const canEdit = !checkIsWFBORWFC();
    if (isSales && !canEdit) {
      return true;
    }
    if (
      isSales &&
      valToString(record[key]) &&
      (isOppIdItemDisabled || !canEdit)
    ) {
      return true;
    }
    return false;
  };

  // oppid 单独处理逻辑
  const formatOppIdArr = (arr: any[] = []) => {
    return arr
      .filter((v) => {
        if (
          v.name === 'OppIDArr' &&
          (!opportunityStatusFromForm ||
            opportunityStatusFromForm === COMMON_BOOLEAN_MAP.no)
        ) {
          return false;
        }
        return true;
      })
      .map((item) => {
        if (item.name === 'opportunityStatus') {
          return {
            ...item,
            disabled: oppidDisabledFn('opportunityStatus')
          };
        }
        return {
          ...item
        };
      });
  };

  const noOppidAlertMessageRender = () => {
    const projectProductLineKeyIsBC = checkIsWFBORWFC();
    return (
      opportunityStatusFromForm === COMMON_BOOLEAN_MAP.no &&
      subjectMatterProjectStatusFromForm === projectStatusMap.duringTender &&
      !projectProductLineKeyIsBC && (
        <div className="sales_feedback_warn">
          由于该项目没有Opportunity
          ID，请留意后续LeadsManagement分配给您的Leads，
          <strong>请再次确认客户单位联系人和客户单位联系方式是否填写</strong>
        </div>
      )
    );
  };

  const renderSalesFeedbackFrom = useMemo(
    () => renderForm(handleSalesFormArr(), form),
    [
      subjectMatterNumberFromForm,
      subjectMatterProjectStatusFromForm,
      attendTenderStatusFromForm,
      loseWinStatusFromForm,
      oldCustomerStatusFromForm,
      opportunityStatusFromForm,
      userList,
      OppIDListFromForm,
      isSubjectMatterNumberChange,
      offlineFormKeyFromForm,
      dealerList,
      subjectMatterProjectSaleIdFromForm,
      corpIdFromForm,
      projectProductLineKeyFromForm,
      projectBrandKeyFromForm,
      projectModelKeyFromForm,
      projectClassKeyFromForm,
      isVersion2,
      createLeadsFromForm,
      coverageStatusFromForm
    ]
  );

  const onOppIdModalOpen = (index: number) => {
    setCurrentOppIdIndex(index);
    if (subjectMatterProjectSaleIdFromForm) {
      setSearchOppIdOpen(true);
    } else {
      message.warning('请先选择负责的销售');
    }
  };

  const handleSearchOppIdOk = (item: OppIdListResInterface) => {
    setSearchOppIdOpen(false);

    if (form.getFieldValue('opportunityStatus') === COMMON_BOOLEAN_MAP.yes) {
      const currentOppIdList = _.cloneDeep(
        form.getFieldValue(OPP_ID_LIST) || []
      ) as OppIdFormItem[];

      currentOppIdList[currentOppIdIndex] = {
        ...createEmptyOppItem(),
        [OPP_ID]: item.oppoId,
        [OPP_CREATED_DATE]: item.oppoCreatedDate || '',
        [OPP_CLOSE_DATE]: item.oppoCloseDate || ''
      };

      form.setFieldsValue({
        [OPP_ID_LIST]: currentOppIdList
      });

      handleCheckOppoId([item]);
    }
  };

  return (
    <>
      <ZeissModal
        open={open}
        width={1100}
        centered
        footer={null}
        onCancel={onModalCancel}
        destroyOnHidden
        className="pc-projectFromComponents-Modal"
      >
        <div className="pc_ProjectFrom_layout">
          <div className="pc-projectFromComponents-title">
            {title ||
              (subjectMatterProjectCode
                ? noticeRecord?.noticeName
                : '新建项目')}
            {isVersion2 ? (
              <span className="pc-projectFromComponents-tit-dealer">经销</span>
            ) : (
              <span className="pc-projectFromComponents-tit-sales">直销</span>
            )}
          </div>
          <div className="pc-projectFromComponents-content">
            {stepItems && stepItems?.length > 1 && (
              <div className="steps_wrap">
                <Steps
                  size="small"
                  className="steps_content"
                  labelPlacement="vertical"
                  current={step}
                  items={stepItems}
                />
              </div>
            )}
            <ZeissCollapse
              items={CollapseItems}
              defaultActiveKey={[ANNOUNCEMENT_COLLAPSE_TYPE.NOTICE]}
              accordion
            ></ZeissCollapse>

            {renderSubjectMatterCollapse()}
            <div className="sales_feedback_wrap">
              <div className="sales_feedback_info">
                <div className="sales_feedback_info_title">销售反馈信息</div>
                {/* <div className="sales_feedback_info_subtitle">
                  2台标的物对应2条Opportunity ID
                </div> */}
              </div>
              <div className="sales_feedback_mian">
                {createTime ? (
                  <div className="sales_feedback_warn_ai">
                    <img src={AiIconImg} alt="ai" />
                    <span>
                      该标的物的产品线、品牌、型号、A/B/C Class
                      基于AI判断，点击右侧帮助按钮查看判断依据
                    </span>
                    <Tooltip
                      placement="top"
                      color="#fff"
                      trigger={'click'}
                      rootClassName="ai-tooltip"
                      title={noticeRecord?.reasoningAi || record.reasoningAi}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>
                ) : null}
                {renderSalesFeedbackFrom}
              </div>
              {noOppidAlertMessageRender()}

              {createLeadsFromForm === COMMON_BOOLEAN_MAP_2.yes && (
                <div className="sales_feedback_warn">
                  如需创建Leads，请确认
                  <strong>客户单位联系人和客户单位联系方式</strong>是否填写
                </div>
              )}
            </div>
          </div>

          <Space className="pc-createAnn-footer" size="middle">
            <ZeissButton
              className="pc-createAnn-cancel"
              onClick={onModalCancel}
            >
              取消
            </ZeissButton>
            <ZeissButton
              type="primary"
              className="pc-createAnn-sales"
              onClick={createProjectHandle}
            >
              {okBtnText ||
                (subjectMatterProjectCode ? '确认修改' : '确认新建')}
            </ZeissButton>
          </Space>
        </div>
      </ZeissModal>
      <SearchOppid
        open={searchOppIdOpen}
        salesUserId={subjectMatterProjectSaleIdFromForm}
        setOpen={setSearchOppIdOpen}
        handleOk={handleSearchOppIdOk}
      />
    </>
  );
};
